
export class SubjectAreaTargetObjectFilterOptions {
    subjectAreaId: number;
    subjectAreaName: string;
    targetObjectIds: Array<number>;
}
